import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { Store, select } from '@ngrx/store'
import { fromJS } from 'immutable'
import { AnimationOptions } from 'ngx-lottie'

@Component({
  selector: 'data-generation-section',
  templateUrl: './data-generation-section.component.html',
  styleUrls: ['./data-generation-section.component.css'],
})
export class DataGenerationSectionComponent implements OnInit, OnDestroy {
  @Input() public data: any
  public options: AnimationOptions = {
    path: '/assets/running.json',
  }
  public states = {
    NOT_RUNNING: 'NOT_RUNNING',
    RUNNING: 'RUNNING',
    FINISHED: 'FINISHED',
    ERRORED: 'ERRORED',
    STOPPED: 'STOPPED',
  }

  constructor(public store: Store<any>) {}

  ngOnInit() {}

  ngOnDestroy() {}

  toMap(obj: any) {
    return fromJS(obj)
  }
}
